// Data types and constants for the student papers management system

export interface AdmissionMethod {
	id: string;
	name: string;
}

export interface Major {
	faculty_code: string;
	ma_nganh: string;
	major_name: string;
	faculty_name: string;
	mssv: string;
}

// Admission methods from HCMUS website.
//
// Ids and names stay hardcoded on purpose: they arrive from upstream
// admissions data and land in `Student.DTT`, so renaming or renumbering them
// would orphan live rows. Which hồ sơ each method requires is no longer here
// — that mapping is now admin-editable through `/v1/catalog`.
export const ADMISSION_METHODS: AdmissionMethod[] = [
	{
		id: "XTT_BoGD",
		name: "Xét tuyển thẳng theo quy định của Bộ Giáo dục & Đào tạo 2025",
	},
	{
		id: "UTX_BoGD",
		name: "Ưu tiên xét tuyển theo quy định của Bộ Giáo dục & Đào tạo 2025",
	},
	{
		id: "XTT_DHQG",
		name: "ƯTXTT Học sinh Giỏi nhất Trường THPT theo quy định của ĐHQG-HCM 2025",
	},
	{
		id: "UTX_DHQG",
		name: "ƯTXT Học sinh Giỏi các trường THPT theo quy định của ĐHQG-HCM 2025",
	},
	{
		id: "NNQT",
		name: "ĐKXT dựa trên kết quả CCNN quốc tế kết hợp kết quả học THPT 2025",
	},
	{
		id: "DGNL",
		name: "ĐKXT dựa trên kết quả kỳ thi ĐGNL do ĐHQG-HCM tổ chức năm 2025",
	},
	{
		id: "THPT",
		name: "ĐKXT dựa trên kết quả thi THPT 2025",
	},

	// --- Khoá tuyển 2026 ---
	//
	// Bộ mã đổi hoàn toàn so với 2025, không phải thêm vào: 2026 dùng `XTT`,
	// `DGNL_HB`, `THPT_HB`, `UTXT`. Bảy mã 2025 ở trên phải GIỮ LẠI vì 4.804 hồ sơ
	// khoá cũ vẫn mang chúng trong `Student.DTT` và danh mục hồ sơ của các diện đó
	// vẫn phải tra được.
	//
	// Tên lấy nguyên văn từ `DienTT` của dữ liệu thật trên production (đếm ngày
	// 2026-08-12). `DGNL_HB` và `THPT_HB` dùng CHUNG một tên nguồn — giữ đúng như
	// nguồn, không tự thêm chú thích phân biệt.
	{
		id: "DGNL_HB",
		name: "Phương thức tổng hợp",
	},
	{
		id: "THPT_HB",
		name: "Phương thức tổng hợp",
	},
	{
		id: "XTT",
		name: "Tuyển thẳng theo quy định của Bộ Giáo dục và Đào tạo 2026",
	},
	{
		id: "UTXT",
		name: "Ưu tiên xét tuyển theo quy định của Bộ Giáo dục và Đào tạo 2026",
	},
];

// Student approval status
export const APPROVAL_STATUS = {
	PENDING: "pending",
	APPROVED: "approved",
} as const;

export type ApprovalStatus = (typeof APPROVAL_STATUS)[keyof typeof APPROVAL_STATUS];

// Fee payment status
export const FEE_STATUS = {
	UNPAID: "UNPAID",
	PAID: "PAID",
} as const;

export type FeeStatus = (typeof FEE_STATUS)[keyof typeof FEE_STATUS];

// Gender options
export const GENDER_OPTIONS = [
	{ value: "Nam", label: "Nam" },
	{ value: "Nữ", label: "Nữ" },
];

// Utility functions
export function getAdmissionMethodById(id: string): AdmissionMethod | undefined {
	return ADMISSION_METHODS.find((method) => method.id === id);
}
